// src/api/supportApi.js
import axiosInstance from './axiosConfig';

export const supportApi = {
  // Get support categories and statuses
  getSupportCategories: async () => {
    const response = await axiosInstance.get('/support/categories');
    return response.data;
  },

  // Vendor tickets
  getVendorTickets: async (params = {}) => {
    const response = await axiosInstance.get('/support/vendor/tickets', { params });
    return response.data;
  },

  createTicket: async (data) => {
    const response = await axiosInstance.post('/support/vendor/tickets', data);
    return response.data;
  },

  getVendorTicket: async (id) => {
    const response = await axiosInstance.get(`/support/vendor/tickets/${id}`);
    return response.data;
  },

  replyToTicket: async (id, data) => {
    const response = await axiosInstance.post(`/support/vendor/tickets/${id}/reply`, data);
    return response.data;
  },

  closeTicket: async (id) => {
    const response = await axiosInstance.put(`/support/vendor/tickets/${id}/close`);
    return response.data;
  },

  getVendorFaqs: async () => {
    const response = await axiosInstance.get('/support/vendor/faqs');
    return response.data;
  },

  // Admin tickets
  getAllTickets: async (params = {}) => {
    const response = await axiosInstance.get('/support/admin/tickets', { params });
    return response.data;
  },

  getTicket: async (id) => {
    const response = await axiosInstance.get(`/support/admin/tickets/${id}`);
    return response.data;
  },

  replyTicket: async (id, data) => {
    const response = await axiosInstance.post(`/support/admin/tickets/${id}/reply`, data);
    return response.data;
  },

  updateTicketStatus: async (id, status, note) => {
    const response = await axiosInstance.put(`/support/admin/tickets/${id}/status`, {
      status,
      note,
    });
    return response.data;
  },

  deleteTicket: async (id) => {
    const response = await axiosInstance.delete(`/support/admin/tickets/${id}`);
    return response.data;
  },

  getSupportStats: async () => {
    const response = await axiosInstance.get('/support/admin/stats');
    return response.data;
  },

  // FAQ management
  getFaqs: async (params = {}) => {
    const response = await axiosInstance.get('/support/admin/faqs', { params });
    return response.data;
  },

  createFaq: async (data) => {
    const response = await axiosInstance.post('/support/admin/faqs', data);
    return response.data;
  },

  updateFaq: async (id, data) => {
    const response = await axiosInstance.put(`/support/admin/faqs/${id}`, data);
    return response.data;
  },

  deleteFaq: async (id) => {
    const response = await axiosInstance.delete(`/support/admin/faqs/${id}`);
    return response.data;
  },
};